import React, {useCallback, useState, useEffect} from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import {ACard} from "@atiautomacao/ati-ui-library";
import {HeaderMenu} from "../HeaderMenu";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {TicketCategory} from "../../../Shared/Types/TicketCategory";
import {
    CreateTicketCategory,
    UpdateTicketCategory,
    FindByIdTicketCategory
} from "./TicketCategoryReactQuery";
import { useAppSelector } from "../../../Config/Hooks";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";

interface TicketCategoryFormProps {
    id?: string,
    handleBack: Function
}

function TicketCategoryForm(props: TicketCategoryFormProps) {

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSave = hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.SAVE_TICKET_CATEGORY, AUTHORITIES.UPDATE_TICKET_CATEGORY ]);
    const {data: findById, isSuccess} = FindByIdTicketCategory(Number(props.id));
    const [formData, setFormData] = useState<TicketCategory>({ name: "" });
    const createTicketCategory = CreateTicketCategory();
    const updateTicketCategory = UpdateTicketCategory();

    const handleSave = () => {
        const opts = {
            onSuccess: () => props.handleBack()
        };
        if (formData.id) {
            updateTicketCategory.mutate(formData, opts);
        } else {
            createTicketCategory.mutate(formData, opts);
        }
    };

    const handleChange = (event: any) => {
        const {name, value} = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    useEffect(() => {
        if (isSuccess && findById.data) {
            setFormData(findById.data);
        }
    }, [findById]);

    return (
        <>
            <HeaderMenu isOnSave={true} handleSave={handleSave} systemRoutes={SystemRoutes.SETTINGS_TICKET_CATEGORY} disableSave={!isAuthorizedToSave} />

            <Box style={{paddingTop: 10}}>
                <ACard styleProps={{ headerStyle: {padding: 0} }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                            <Grid item md={8} xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        name="name"
                                        value={formData.name}
                                        variant="standard"
                                        label="Nome"
                                        onChange={handleChange}
                                     />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                </ACard>
            </Box>
        </>
    );
}

export default function TicketCategoryFormPage() {
    const queryClient = new QueryClient();
    const location = useLocation();
    const navigate = useNavigate();
    const id = location.state?.id as string;

    return (
        <QueryClientProvider client={queryClient}>
            <TicketCategoryForm id={id} handleBack={() => { navigate(SystemRoutes.SETTINGS_TICKET_CATEGORY); }} />
        </QueryClientProvider>
    )
}